import EntryRoute from './EntryRoute';

export default EntryRoute;
